import { parseCurrency } from '@helper/parseCurrency'

import { displayDateBrazilian } from '../../util/standardizedDate'

const difValueFormatted = (
  rsMetaReceitaLiquida: number,
  margemLiquidaPercentual: number,
  margemLiquidaAlvo: number
) => {
  const value = rsMetaReceitaLiquida
    ? margemLiquidaPercentual - (margemLiquidaAlvo / rsMetaReceitaLiquida) * 100
    : 0

  return valueWithoutRounding(value)
}

const valueWithoutRounding = (value: number) => {
  return +value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
}

const formattedDate = (date: string) => {
  return displayDateBrazilian(date)
}

const formatNumber = (value: number) => {
  return value.toString().replace('.', ',')
}

export const parseSalesKpiData = (data: any[]): any[] => {
  return data?.length === 0
    ? []
    : data.map(item => {
        return {
          'data-execucao-id': item.periodo ? formattedDate(item.periodo) : 0,

          'cd-loja-codigo-id': item.lojaId ? item.lojaId : 0,
          'cd-loja-nome-id': item.lojaDescricao ? item.lojaDescricao : '',

          'gerente-categoria-id': item.gerenteCategoriaDescricao
            ? item.gerenteCategoriaDescricao
            : '',
          'gerente-produto-id': item.gerenteProdutoDescricao
            ? item.gerenteProdutoDescricao
            : '',

          'mundo-codigo-id': item.mundoId ? item.mundoId : 0,
          'mundo-nome-id': item.mundoDescricao ? item.mundoDescricao : '',

          'categoria-compacta-codigo-id': item.categoriaCompactaId
            ? item.categoriaCompactaId
            : 0,
          'categoria-compacta-nome-id': item.categoriaCompactaDescricao
            ? item.categoriaCompactaDescricao
            : '',

          'categoria-codigo-id': item.categoriaId ? item.categoriaId : 0,
          'categoria-nome-id': item.categoriaDescricao
            ? item.categoriaDescricao
            : '',

          'status-nome-id': item.statusDescricao ? item.statusDescricao : '',

          'curva-abc-nome-id': item.curvaABCDescricao
            ? item.curvaABCDescricao
            : '',

          'fornecedor-codigo-id': item.fornecedorId ? item.fornecedorId : 0,
          'fornecedor-nome-id': item.fornecedorDescricao
            ? item.fornecedorDescricao
            : '',

          'empresa-codigo-id': item.empresaId ? item.empresaId : 0,
          'empresa-nome-id': item.empresaDescricao ? item.empresaDescricao : '',

          'venda-bruta-id': item.rsReceitaBruta
            ? parseCurrency({
                value: item.rsReceitaBruta,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'venda-liquida-id': item.rsReceitaLiquida
            ? parseCurrency({
                value: item.rsReceitaLiquida,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'venda-orcada-liq-id': item.rsMetaReceitaLiquida
            ? parseCurrency({
                value: item.rsMetaReceitaLiquida,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'venda-realizado-liq-id': formatNumber(
            item.rsMetaReceitaLiquidaRealizada
          ),
          'venda-bruta-btleo-id': item.btReceitaBruta
            ? parseCurrency({
                value: item.btReceitaBruta,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'venda-liquida-btleo-id': item.btReceitaLiquida
            ? parseCurrency({
                value: item.btReceitaLiquida,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'venda-orcada-btleo-id': item.btMetaReceitaLiquida
            ? parseCurrency({
                value: item.btMetaReceitaLiquida,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'venda-realizado-btleo-id': formatNumber(
            item.btMetaReceitaLiquidaRealizada
          ),

          'margem-liquida-id': item.margemLiquida
            ? parseCurrency({
                value: item.margemLiquida,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'margem-orcada-id': item.margemLiquidaAlvo
            ? parseCurrency({
                value: item.margemLiquidaAlvo,
                country: 'pt-br'
              })
            : parseCurrency({ value: 0, country: 'pt-br' }),
          'margem-atual-id': formatNumber(item.margemLiquidaPercentual),
          'margem-orcada-porc-id': formatNumber(
            item.margemLiquidaPercentualAlvo
          ),
          'margem-dif-id': difValueFormatted(
            item.rsMetaReceitaLiquida,
            item.margemLiquidaPercentual,
            item.margemLiquidaAlvo
          ),
          'subcategoria-codigo-id': item.subCategoriaId
            ? item.subCategoriaId
            : 0,
          'subcategoria-nome-id': item.subCategoriaDescricao
            ? item.subCategoriaDescricao
            : ''
        }
      })
}
